import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api"
import { Link } from "react-router-dom"
import "./map.css"
import { useDarkMode } from "utils/general"
import { darkStyles } from "./styles"

const DefaultMap = props => {
  const [lat, setLat] = useState(0)
  const [lng, setLng] = useState(0)
  const [showInfo, setShowInfo] = useState(false)
  const center = useMemo(() => ({ lat: lat, lng: lng }), [lat, lng])
  const isDarkMode = useDarkMode();

  useEffect(() => {
    let tempLat = props.lat
    if (!tempLat) tempLat = 0
    if (typeof tempLat === "string") tempLat = Number.parseFloat(tempLat)

    if (tempLat != lat) {
      //console.log("Lat: ", props.lat, tempLat)
      setLat(tempLat)
    }
  }, [props.lat])

  useEffect(() => {
    let tempLng = props.lng
    if (!tempLng) tempLng = 0
    if (typeof tempLng === "string") tempLng = Number.parseFloat(tempLng)

    if (tempLng != lng) {
      //console.log("Lng: ", props.lng, tempLng)
      setLng(tempLng)
    }
  }, [props.lng])

  // Switch between dark styles and default (empty array)
  const options = useMemo(() => ({
    styles: isDarkMode ? darkStyles : [],
    disableDefaultUI: false,
  }), [isDarkMode]);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_APIKEY,
  })
  if (!isLoaded)
    return (
      <div className="text-center py-5 my-3">
        <Link to="#" className="text-primary">
          <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
        </Link>
      </div>
    )

  return (
    <GoogleMap
      zoom={props.zoom}
      center={center}
      mapContainerClassName="google-map"
      options={options}
      onClick={e => {
        if (props.markerEdit) {
          //console.log("Map clicked: ", e)
          setLat(e.latLng.lat())
          setLng(e.latLng.lng())
          if (props.markerChanged) {
            props.markerChanged(e.latLng.toJSON())
          }
        }
      }}
    >
      <Marker
        position={{ lat: lat, lng: lng }}
        draggable={props.markerEdit != undefined ? props.markerEdit : false}
        onDragEnd={e => {
          if (props.markerEdit) {
            //console.log("Marker dragged: ", e)
            setLat(e.latLng.lat())
            setLng(e.latLng.lng())
            if (props.markerChanged) {
              props.markerChanged(e.latLng.toJSON())
            }
          }
        }}
        onClick={() => {
          setShowInfo(!showInfo)
        }}
        icon={{
          url: require("./../../assets/images/icons/ic_marker_home_156.png"),
          scaledSize: new google.maps.Size(56, 56), // scaled size
        }}
      >
        {props.infoText && showInfo && (
          <InfoWindow
            position={{ lat: lat, lng: lng }}
            //options={{ maxWidth: 100 }}
            onCloseClick={() => {
              setShowInfo(false)
            }}
          >
            <div>
              {props.infoHeader && <h6>{props.infoHeader}</h6>}
              <p>{props.infoText}</p>
              <a
                href={"https://www.google.com/maps/place/" + lat + "," + lng}
                target="_blank"
                rel="noreferrer"
              >
                <i className="mdi mdi-arrow-right float-end font-size-18"></i>
              </a>
            </div>
          </InfoWindow>
        )}
      </Marker>
    </GoogleMap>
  )
}

DefaultMap.propTypes = {
  lat: PropTypes.any,
  lng: PropTypes.any,
  zoom: PropTypes.any,
  infoHeader: PropTypes.string,
  infoText: PropTypes.string,
  markerEdit: PropTypes.bool,
  markerChanged: PropTypes.func,
}

export default DefaultMap
